import "../elements/clipboard";
import { Clipboard } from "../elements/clipboard";
import { getSingleton } from "./singleton";

export async function setClipboard(value: string, label?: string, duration?: number) {
    const singleton = getSingleton("pl-clipboard") as Clipboard;
    return singleton.set(value, label, duration);
}

export function clearClipboard() {
    const singleton = getSingleton("pl-clipboard") as Clipboard;
    singleton.clear();
}
